import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DialogResult, DialogResultType } from "../DialogResult";

export interface DodField {
  key: string;
  label: string;
  type: "text" | "textarea" | "number" | "select" | "checkbox" | "multiselect";
  options?: { value: any; label: string }[];
  readonly?: boolean;
  hint?: string;
  placeholder?: string;
  // text fields: save an empty value as null (ids, optional text)
  emptyAsNull?: boolean;
  // grid width (Bootstrap columns out of 12)
  width?: number;
}

export interface DodEditDialogData {
  title: string;
  model: any;
  fields: DodField[];
  saveLabel?: string;
  // Shown when set; clicking returns DialogResultType.Delete.
  deleteLabel?: string;
  // Shown when set; clicking returns DialogResultType.Yes (used for "Rename...").
  renameLabel?: string;
  note?: string;
}

// One form dialog for every DoD definition row (endpoint, sub-data, column, measure, dimension, aggregate type): the
// fields are described by the caller, so the six editors do not need six near-identical dialogs.
@Component({
  selector: "dod-edit-dialog",
  templateUrl: "./dod-edit-dialog.component.html",
})
export class DodEditDialogComponent {
  public model: any;
  public Result: DialogResult = { ResultType: DialogResultType.Cancel, ResultData: null };

  constructor(public dialogRef: MatDialogRef<DodEditDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DodEditDialogData) {
    this.model = { ...data.model };
  }

  private finish(type: DialogResultType) {
    const result = { ...this.model };
    for (const f of this.data.fields) {
      if (f.type === "text" && f.emptyAsNull && (result[f.key] === "" || result[f.key] === undefined)) result[f.key] = null;
    }
    this.Result.ResultType = type;
    this.Result.ResultData = result;
    this.dialogRef.close(this.Result);
  }

  onSave(): void { this.finish(DialogResultType.Ok); }
  onDelete(): void { this.finish(DialogResultType.Delete); }
  onRename(): void { this.finish(DialogResultType.Yes); }
  onCancelClick(): void { this.dialogRef.close(this.Result); }

  cols(f: DodField): string { return "col-md-" + (f.width || 6); }

  static showDialog(dialog: MatDialog, data: DodEditDialogData): Observable<DialogResult> {
    return dialog.open(DodEditDialogComponent, { disableClose: false, width: "720px", data }).afterClosed();
  }
}
